module.exports = "/_next/static/images/c47579269e110dee0a618620518d5070-fees-left-lg.jpg.webp";